import { render } from "./PersonalDetails.vue?vue&type=template&id=2cd61ef0&scoped=true&ts=true"
import script from "./PersonalDetails.vue?vue&type=script&lang=ts"
export * from "./PersonalDetails.vue?vue&type=script&lang=ts"

import "./PersonalDetails.vue?vue&type=style&index=0&id=2cd61ef0&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2cd61ef0"],['__file',"src/components/kyc/PersonalDetails.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "2cd61ef0"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('2cd61ef0', __exports__)) {
    api.reload('2cd61ef0', __exports__)
  }
  
  module.hot.accept("./PersonalDetails.vue?vue&type=template&id=2cd61ef0&scoped=true&ts=true", () => {
    api.rerender('2cd61ef0', render)
  })

}


export default __exports__